<template>
    <router-view></router-view>
</template>
<script>
export default {
  name: 'groups',
  components: {}
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/Groups.vue